<app-block-wrapper [_editable]="_editable" [style]="style">
  <div class="promo-spacer" *ngIf="isAtleastOnePromo"></div>
  <div class="boxes">
    <div
      *ngFor="let product of products"
      class="box thirds style-{{ product.color }}"
      [attr.data-test-id]="product.name"
      [class.promo]="productPromos[product.id]"
      [appStoryblok]="product._editable"
    >
      <div class="promo-banner" *ngIf="productPromos[product.id]">
        <app-svg src="/assets/icons/discount.svg"></app-svg>
        <span>{{ productPromos[product.id].name }}</span>
      </div>
      <div class="shadow-box">
        <div class="mobile-side-container">
          <div class="pricing-container">
            <div class="price-container">
              <div class="price-name">
                <span>{{ product.name }}</span>
              </div>
              <div class="price-amount-container">
                <div class="price-amount">
                  <span>${{ product.priceDetails.displayAmountWhole | customCurrency : '' }}</span>
                  <div class="cents" *ngIf="product.priceDetails.displayAmountCents">
                    {{ product.priceDetails.displayAmountCents | customCurrency : '' }}
                  </div>
                </div>

                <ng-container *ngIf="!product.isFree">
                  <div
                    class="price-duration-info"
                    tooltipSize="big"
                    tooltipStyle="light"
                    appTooltip
                    [skipDelay]="true"
                    [tooltipHtmlContent]="getTooltipContent(product)"
                  >
                    <div>per month*</div>
                    <ng-container *ngIf="product.priceDetails.monthlyDiscountAmount">
                      <div class="crossed-out">
                        instead of {{ product.priceDetails.yearlyAmountWithoutDiscount / 12 | customCurrency }}
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="price-description" *onlyForScreens="['desktop', 'tablet']">
              {{ product.description }}
            </div>
          </div>

          <div class="list no-hover main-product-features">
            <div
              class="list-item"
              *ngFor="let point of product.points"
              [appStoryblok]="point._editable"
              [class.faded]="point.icon === 'cross'"
              appTooltip=""
              [tooltipHtmlContent]="point.tooltipContent"
              [showOnMobile]="true"
              [tooltipStyle]="'light'"
              [tooltipSize]="'big'"
              [skipDelay]="true"
            >
              <app-svg class="list-item-icon" src="/assets/icons/{{ point.icon }}.svg"></app-svg>
              <div [class.has-tooltip]="!!point.tooltipContent">
                {{ point.text }}
              </div>
              <app-svg src="/assets/icons/16/info.svg" class="feature-info-icon" *ngIf="point.tooltipContent"></app-svg>
            </div>
          </div>
        </div>

        <div class="cta-container">
          <a
            *ngIf="!!getUrl(product)"
            [routerLink]="getUrl(product)"
            appButton
            name="{{ product.name | lowercase }}"
            location="pricing-box-list"
            [color]="product.color"
            spacing="full"
            size="3"
            height="3"
            heightMobile="3"
            shape="round"
            weight="bold"
          >
            <ng-container *ngIf="allowTrial && !product.isFree">Start Free Trial</ng-container>
            <ng-container *ngIf="allowTrial && product.isFree">Get Started</ng-container>
            <ng-container *ngIf="!allowTrial">Get Started</ng-container>
          </a>
        </div>
      </div>
    </div>
  </div>
</app-block-wrapper>
